
<multi-input class="component">
  <prefix>
    <label :for="filterElement.idForProp('filter')">
      <span class="icon searchable"></span>
    </label>
  </prefix>
  <column>
    <input
      v-model="q"
      @input="clearSearchIfExactMatchesOnly"
      @keyup.enter="handleEnterKey"
      type="search"
      :id="filterElement.idForProp('filter')"
      :placeholder="filterElement.placeholder_text"
    />
  </column>
  <suffix>
    <button @click="reset" type="reset" class="btn-icon">
      <span class="sr-only">clear</span>
      <span class="icon times"></span>
    </button>
  </suffix>
</multi-input>
